import styled from 'styled-components';
var NavigationOverlay = styled.div.withConfig({
  displayName: "NavigationOverlay",
  componentId: "sc-17fk2pi-0"
})(["height:100vh;width:100vw;background-color:transparent;opacity:0;position:fixed;top:0;left:0;z-index:1;pointer-events:", ";"], function (props) {
  return props.$isActive ? 'all' : 'none';
});
export default NavigationOverlay;